// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upcoming-banner[data-v-250cb48b]{border-top-left-radius:8px;border-top-right-radius:8px;background-color:rgba(0,41,11,.75);color:#00e03c;font-size:14px;font-weight:400;font-style:normal;letter-spacing:.21px;padding:8px 16px;display:flex;align-items:center;justify-content:flex-start;gap:8px}", ""]);
// Exports
module.exports = exports;
